<template>
    <div class="home-page">
        <page-image-top :title="$t(`pages.contact.title`)" image="/static/backgrounds/table-bottom.png" />

        <section class="section">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <h2 class="subtitle is-size-4">Taskflex ApS</h2>

                        <ul>
                            <li>Dybendal Alle 12</li>
                            <li>2630 Taastrup</li>
                            <li>Danmark</li>
                            <li>Telefon: +45 60 55 44 33</li>
                            <li>Email: info@taskflex.dk</li>
                            <li>CVR: 38 51 87 20</li>
                        </ul>
                    </div>

                    <div class="column">
                        <h2 class="subtitle is-size-4">Kontaktmuligheder</h2>

                        <p>Du har flere muligheder for at komme i kontakt med os.</p>

                        <p>Vi har ikke faste telefontider og kan derfor ikke garantere at du får fat i os via telefonen. Prøv derfor helst en af de andre metoder først.</p>

                        <br>
                        <br>

                        <div class="columns has-text-centered is-mobile">
                            <div class="column">
                                <a href="https://m.me/Taskflex" target="_blank" rel="nofollow">
                                    <b-icon icon="facebook" size="is-large" />
                                    <br>
                                    <br>

                                    Kontakt os via Facebook
                                </a>
                            </div>

                            <div class="column">
                                <a href="mailto:info@taskflex.dk" target="_blank" rel="nofollow">
                                    <b-icon icon="email" size="is-large" />
                                    <br>
                                    <br>

                                    Kontakt os via Email
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="hero is-primary">
            <div class="hero-body">
                <h1 class="title is-spaced has-text-centered is-uppercase">
                    Klar til at få opgaven løst?
                </h1>

                <p class="subtitle has-text-centered">
                    <router-link class="button is-primary is-inverted is-outlined is-medium" :to="{ name: 'students.search' }">
                        Find studerende
                    </router-link>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import PageImageTop from '@/global/components/PageImageTop';

    export default {
        components: {
            PageImageTop,
        },
    };
</script>



// WEBPACK FOOTER //
// src/infrastructure/home/pages/Contact.vue